<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        dark
        v-on="on"
      >
        Create Award
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Award"
      text="Create Award"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Name"
              />
            </v-col>
            <v-col cols="12">
              <helper-image-input  
                v-model="image" 
                v-validate="'required'"
                :max-size-in-mb="2"
                data-vv-name="image"
                field-name="image"
                accept-type=".svg"     
                extension="ext:svg"       
              >          
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-btn                    
                    :disabled="progressing"
                    class="mx-2"    
                  >
                    Add Image
                  </v-btn>
                  <span>
                    {{ image ? image.imageFile.name : 'No file chosen (.svg only)' }}
                  </span>
                </div>
              </helper-image-input>
              <span class="red--text text--lighten-1">{{ errors.first('image') }}</span>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      HelperImageInput: () => import('@/components/helper/ImageInput'),
    },
    inject: ['$validator'],
    data () {
      return {
        progressing: false,
        dialog: null,
        name: null,
        image: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        
        this.resetForm()
      },
    },
    methods: {    
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.setProgressing(true)
            this.image.formData.set('name', this.name)
    
            this.$api.awards().create(this.image.formData)
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created', { ...res.data })                
                  this.$snack({ message: 'Added new award' })

                  this.setDialog(false)                
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      setDialog (status) {
        this.dialog = status
      },
      resetForm () {
        this.name = null
        this.image = null
        this.$validator.reset()
      },
    },
  }
</script>
